// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Currency from "../../../../../../../../library/data-source/country-currency/Currency.bs.js";

function getTollsVm(tolls, currency) {
  return List.map((function (t) {
                return {
                        name: t.title,
                        amount: Currency.toCurrencyString(t.amount, currency)
                      };
              }), tolls);
}

function getVm(order_fare, currency) {
  var fare = order_fare.fare_details.customer;
  if (fare !== undefined) {
    return getTollsVm(fare.breakup_details.toll_breakup_details, currency);
  } else {
    return getTollsVm(order_fare.fare_details.estimated.breakup_details.toll_breakup_details, currency);
  }
}

export {
  getTollsVm ,
  getVm ,
  
}
/* No side effect */
